/* eslint-disable no-param-reassign */
import type { Module } from 'vuex';
import type { DeferRootState, ResultState } from '../constants';

export function getResultModule(): Module<ResultState, DeferRootState> {
  return {
    namespaced: true,

    state: {
      /** 是否展示结果页 */
      showResult: false,
      /** 结果页数据 */
      resultData: {} as PageData | showStatusDataType,
      /** 是否已签约 */
      signed: false,
    },

    mutations: {
      setShowResult(state, payload: { showResult: boolean }): void {
        state.showResult = payload.showResult;
      },
      setResultData(state, payload: { resultData: PageData | showStatusDataType }): void {
        state.resultData = payload.resultData;
      },
      setSignedStatus(state, payload: { signed: boolean }): void {
        state.signed = payload.signed;
      },
    },
  };
}
